import { ChangelogUpdateDocument, ChangelogUpdateMutationVariables } from '@cycle-app/graphql-codegen';

import { getPermission, setLimitationsModal } from '../../reactives';
import useSafeMutation from '../useSafeMutation';

export const useChangelogUpdate = () => {
  const [updateMutation, { loading: isLoading }] = useSafeMutation(ChangelogUpdateDocument);

  const changelogUpdate = async (variables: ChangelogUpdateMutationVariables) => {
    if (!getPermission().canUpdateRelease) {
      setLimitationsModal({ action: 'RELEASE_UPDATE' });
      return null;
    }
    return updateMutation({
      optimisticResponse: {
        updateChangelog: variables,
      },
      variables,
    });
  };

  return {
    changelogUpdate,
    isLoading,
  };
};
